import { Box, makeStyles, styled } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: 'unset',
    border: 'none',
  },
}));

export const InfovViewImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  cursor: 'pointer',
}));

export const MainCarImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: '8px',
}));
